import { z } from 'zod/v4';
const StringOperators = [
    '=',
    '!=',
    'contains',
    'not contains',
    'starts with',
    'in',
    'not in',
];
const NumericOperators = ['=', '!=', '<', '>', '<=', '>=', 'to'];
const BaseSearchFieldSchema = z.object({
    key: z.string().describe('The actual field path in the search index'),
    name: z
        .string()
        .optional()
        .describe('The field name. This could be an alias.'),
});
const StringSearchFieldSchema = z.object({
    ...BaseSearchFieldSchema.shape,
    type: z.literal('string'),
    op: z.enum(StringOperators),
    value: z.string().array(),
});
const FactedStringSearchFieldSchema = z.object({
    ...StringSearchFieldSchema.shape,
    type: z.literal('faceted_string'),
});
const NumericSearchFieldSchema = z.object({
    ...BaseSearchFieldSchema.shape,
    type: z.literal('numeric'),
    op: z.enum(NumericOperators),
    // Is this weird
    value: z.number().or(z.tuple([z.number(), z.number()])),
});
const DateSearchFieldSchema = z.object({
    ...NumericSearchFieldSchema.shape,
    type: z.literal('date'),
});
export const SearchFieldSchema = z.discriminatedUnion('type', [
    StringSearchFieldSchema,
    FactedStringSearchFieldSchema,
    NumericSearchFieldSchema,
    DateSearchFieldSchema,
]);
export const OperatorsByType = {
    string: StringOperators,
    numeric: NumericOperators,
    date: NumericOperators,
    faceted_string: StringOperators,
};
export const SearchFilterValueNodeSchema = z.object({
    type: z.literal('value'),
    fieldSpec: SearchFieldSchema,
});
// Hack to get recursive types working in zod
export const SearchFilterOperatorNodeSchema = z.object({
    type: z.literal('op'),
    op: z.enum(['or', 'and']),
    grouped: z.boolean().optional(),
    get children() {
        return SearchFilterQuerySchema.array();
    },
});
export const SearchFilterQuerySchema = z.discriminatedUnion('type', [
    SearchFilterOperatorNodeSchema,
    SearchFilterValueNodeSchema,
]);
export const SearchSortFields = [
    'title',
    'sortTitle',
    'duration',
    'originalReleaseDate',
    'originalReleaseYear',
    'index',
];
export const SearchSortSchema = z.object({
    field: z.enum(SearchSortFields),
    direction: z.enum(['asc', 'desc']),
});
export const SearchRequestSchema = z.object({
    query: z.string().nullish(),
    restrictSearchTo: z.string().array().optional(),
    filter: SearchFilterQuerySchema.nullish(),
    sort: SearchSortSchema.array().nullish(),
});
export function isSearchFieldSpecOfType(spec, type) {
    return spec.type === type;
}
//# sourceMappingURL=SearchRequest.js.map